




















import { defineComponent, ref, PropType, computed } from '@vue/composition-api';
import { useRoute } from '@/hooks/use-route';
import { language } from '@tencent/ppd-base-libs';
import SvgIcon from '../common/svg-icon.vue';
import { biClick } from '@tencent/fit-bi-sdk';
import { PastNgoItemComType } from '@/types/past';

export default defineComponent({
  name: 'NgoStampNgoItem',
  props: {
    item: {
      reuqired: true,
      type: Object as PropType<PastNgoItemComType>,
      default: () => ({ key: '' }),
    },
  },
  components: { SvgIcon },
  setup(props) {
    const lang = ref(language.getLanguage());
    // 处理多语言
    const name = computed(() => (language.isEn() ? props.item.enName : props.item.name));
    const desc = computed(() => (language.isEn() ? props.item.descEn : props.item.desc));
    const biExt = {
      fngo_item_name: props.item.name,
    };
    // 路由
    const route = useRoute();
    // 跳转详情
    const handleGoDetail = (key: string) => {
      route.router.push(`/ngo/${key}?isExpiredFlag=1`);
      biClick('engo-item.item_click|捐赠项目点击', biExt);
    };

    return {
      // 是否英文
      lang,
      name,
      desc,
      handleGoDetail,
      biExt,
    };
  },
});
